import React from "react";

import styled from "styled-components";
const LuxuryTextArea = styled.textarea`
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 0 !important;
  box-sizing: border-box !important;
  border: 1px solid rgb(37, 37, 37) !important;
  background-color: #fff;
  outline: 0;

  margin: 0;
  font-family: inherit;
  overflow: visible;
  display: block;
  width: 100%;

  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  min-height: 38px !important;
  border-radius: 0 !important;
  box-sizing: border-box !important;
  border: 1px solid rgb(37, 37, 37) !important;
  padding-right: calc(1.5em + 0.75rem);
  // border-color: #dc3545 !important;
  border-color: #000000 !important;

  :focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

const FormTextArea = (props) => {
  const { value } = props.input;

  return (
    <LuxuryTextArea onChange={props.input.onChange} {...props} value={value} />
  );
};

export default FormTextArea;
